export const errorMessagesFirebaseAuth = {
  "auth/email-already-in-use": "The email address is already in use by another account.",
  "auth/invalid-email": "The email address is badly formatted.",
  "auth/operation-not-allowed": "The email/password accounts are not enabled.",
  "auth/user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
  "auth/wrong-password": "The password is invalid or the user does not have a password.",
  "auth/invalid-credential": "The email or password is invalid.",
};